import { render, staticRenderFns } from "./ComboboxByCity.vue?vue&type=template&id=15b16b34&"
import script from "./ComboboxByCity.vue?vue&type=script&lang=js&"
export * from "./ComboboxByCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports